export default __webpack_public_path__ + "static/media/Instagram_gd.9195e405.svg";